import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UrlConstructorService {

  constructor() { }

  // baseURLHyphenSlash(paramsDict: { [key: string]: string }): {
  //   [key: string]: string;
  // } {
  //   const updatedParamsDict = { ...paramsDict }; // Create a copy of the original dictionary
  //   if (updatedParamsDict['url']) {
  //     // Replace hyphens with slashes in the base URL
  //     updatedParamsDict['url'] = updatedParamsDict['url'].replace(/\//g, '_');
  //   }
  //   return updatedParamsDict;
  // }

  baseViewUnderscoreSwitch(paramsDict: { [key: string]: string }): {
    [key: string]: string;
  } {
    const updatedParamsDict = { ...paramsDict }; // Create a copy of the original dictionary
    if (updatedParamsDict['view']) {
      // Replace hyphens with slashes in the base URL
      updatedParamsDict['view'] = updatedParamsDict['view'].replace(/_/g, '/');
    }
    return updatedParamsDict;
  }

  constructForwardURL(paramsDict: { [key: string]: string }): string {
    // Ensure the base URL slashes are switched to hyphens if needed
    const updatedParamsDict = this.baseViewUnderscoreSwitch(paramsDict);

    const app = String(updatedParamsDict['app']);
    const view = String(updatedParamsDict['view']);
    const environmentKey = app as keyof typeof environment;
    const baseUrl = decodeURIComponent(environment.frontend_base).replace(/\/$/, '')
    ;

    const baseURLAndView = decodeURIComponent(`${baseUrl}${updatedParamsDict['url']}`)
    let finalUrl = `${baseUrl}/${view}?`

    delete updatedParamsDict['url']
    //Getting key-value pairs together


    function createQueryString(data: { [key: string]: string }): string {
      const params: string[] = [];

      for (let i = 0; ; i++) {
        const keyKey = `key${i}`;
        const valueKey = `value${i}`;
        const keyValue = data[keyKey];
        const valueValue = data[valueKey];

        if (keyValue === undefined && valueValue === undefined) {
          break;
        }

        if (keyValue !== undefined) {
          params.push(`${encodeURIComponent(keyKey)}=${encodeURIComponent(keyValue)}`);
        }
        if (valueValue !== undefined) {
          params.push(`${encodeURIComponent(valueKey)}=${encodeURIComponent(valueValue)}`);
        }
      }

      return params.join('&');
    }

    let queryString = createQueryString(updatedParamsDict)


    finalUrl = finalUrl+queryString

    return finalUrl;
  }

  constructParamURL() {
    // Retrieve the forwardURL from localStorage
    const encodedForwardURL = localStorage.getItem('forwardURL');
    if (!encodedForwardURL) {
      console.log('No forwardURL found in localStorage');
      return;
    }

    // Decode the forwardURL
    const forwardURL = decodeURIComponent(encodedForwardURL);

    // Extract the parts of the forwardURL
    const url = new URL(forwardURL);

    // Find the environment key (appName) that matches the forwardURL's origin
    const appName = (
      Object.keys(environment) as (keyof typeof environment)[]
    ).find((key) => {
      const envItem = environment[key];
      if (typeof envItem === 'object' && 'frontend_base' in envItem) {
        return envItem.frontend_base === `${url.origin}/`;
      }
      return false;
    });

    if (!appName) {
      console.log('No matching app found in environment');
      return;
    }

    // Construct query parameters
    const queryParams = new URLSearchParams({
      app: appName,
      url: `_${url.pathname.slice(1)}`, // remove the leading '/'
    });

    let keyIndex = 0;
    url.searchParams.forEach((value, key) => {
      queryParams.append(`key${keyIndex}`, key);
      queryParams.append(`value${keyIndex}`, value);
      keyIndex++;
    });

    // Construct the new login URL
    const loginURL = new URL(environment.frontend_base + 'login');
    loginURL.search = queryParams.toString();

    return loginURL.toString();
  }
}
